import { Edit } from "@wix/wix-ui-icons-common";
import React, { useContext, useState } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import {
  getIsModalOpen,
  useModalService,
  useModalState
} from "./../../ricos-modals/modal-service-provider.js";
import { ToolbarButton } from "./../../_shared/toolbar-button/toolbar-button.js";
import { FLOATING_PLUGIN_TOOLBAR } from "./../../toolbars-v3/index.js";
import { InsertModal } from "./insert-modal/InsertModal.js";
const EditHtmlButton = ({ toolbarItem, dataHook, id }) => {
  const [referenceElement, setReferenceElement] = useState(null);
  const { t, isMobile } = useContext(RicosContext) || {};
  const modalService = useModalService();
  const isModalOpen = useModalState(getIsModalOpen(id));
  const onClick = () => {
    const componentProps = {
      nodeId: toolbarItem.attributes.selectedNode.attrs.id,
      closeModal: () => modalService.closeModal(id)
    };
    const isModalOpen2 = modalService.isModalOpen(id);
    isModalOpen2 ? modalService.closeModal(id) : modalService.openModal({
      Component: InsertModal,
      id,
      componentProps,
      layout: isMobile ? "fullscreen" : "floating",
      positioning: {
        referenceElement: referenceElement?.closest(`[data-hook~=${FLOATING_PLUGIN_TOOLBAR}]`) ?? referenceElement,
        placement: "right-start"
      },
      withTransition: true,
      noPadding: true,
      type: "exclusive",
      enableDrag: !isMobile,
      dragHandleSelector: "[data-drag-handler]",
      returnFocusToEditor: true,
      focusReturnElement: referenceElement ?? void 0
    });
  };
  return /* @__PURE__ */ React.createElement(
    ToolbarButton,
    {
      active: isModalOpen,
      dataHook,
      label: t("HtmlPlugin_EditHtml_Tooltip"),
      prefix: Edit,
      ariaLabel: t("HtmlPlugin_EditHtml_Tooltip"),
      onClick,
      ref: setReferenceElement,
      tabIndex: toolbarItem.presentation.tabIndex
    }
  );
};
export {
  EditHtmlButton
};
//# sourceMappingURL=EditHtmlButton.js.map
